import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../dashboard/dashboard";
import Header from "../common/header/header";
import Footer from "../common/footer/footer";
import Department from "../academic/department/department";
import Login from "../authentication/login/login";
import ForgotPassword from "../authentication/login/forgot-password";
import Sample from "../sample/sample";
import HRBank from "../human-resources/bank/hr-bank";
import Modules from "../academic/modules/modules";
import TimetableSettings from "../academic/timetable/timetable-settings";
import AddEditStaff from "../human-resources/staff/add-edit-staff";
import HRQualifications from "../human-resources/qualifications/hr-qualifications";
import Faculty from "../academic/faculty/faculty";
import HRDesignations from "../human-resources/designations/hr-designations";
import HRTitle from "../human-resources/title/hr-title";
import RegistrationDashboard from "../registration/admissions/Dashboard";
import EditApplicant from "../registration/admissions/EditApplicant";
import SupportingDocument from "../registration/admissions/supporting-document/SupportingDocument";
import Course from "../academic/course/course";
import TimetableStudentGroup from "../academic/timetable/student-group/timetable-student-group";
import HRNationality from "../human-resources/nationality/hr-nationality";
import UploadStaffDocument from "../human-resources/staff/upload-staff-document";
import UploadStaffPhoto from "../human-resources/staff/upload-staff-photo";
import UploadStudentPhoto from "../registration/student/upload-student-photo";
import ProcessApplication from "../registration/admissions/ProcessApplication-ug";
import AddStaffQualifications from "../human-resources/staff/add-staff-qualications";
import TimetableSemester from "../academic/timetable/semester/timetable-semester";
import ProcessApplicationPg from "../registration/admissions/ProcessApplication-pg";
import HRPensionSettings from "../human-resources/pension/settings/hr-pension-settings";
import AddEditStaffPensionRecord from "../human-resources/staff/add-edit-staff-pension";
import HRPensionAdministrator from "../human-resources/pension/administrator/hr-pension-administrator";
import HRPensionReport from "../human-resources/pension/report/hr-pension-report";
import HRPensionStaffEnrolledReport from "../human-resources/pension/staff-enrolled/hr-pension-staff-enrolled";
import HRPensionStaffNotEnrolledReport from "../human-resources/pension/staff-not-enrolled/hr-pension-staff-not-enrolled";
import JobOpenings from "../human-resources/jobs/job-openings";
import HRGeneralLedger from "../human-resources/payroll/general-ledger/hr-general-ledger";
import HRPayrollManageAllowanceAndDeduction from "../human-resources/payroll/manage-allowance-and-deduction/hr-payroll-manage-allowance-and-deduction";
import JobApplications from "../human-resources/jobs/job-applications";
import JobApplicationDetails from "../human-resources/jobs/applicant-details/job-application-details";
import StaffProfile from "../human-resources/staff-profile/staff-profile";
import HRPayrollRunAllowanceAndDeduction from "../human-resources/payroll/run-allowance-and-deduction/hr-payroll-run-allowance-and-deduction";
import HrPayrollPostSchedule from "../human-resources/payroll/post-schedule/hr-payroll-post-schedule";
import HrPayrollSendPayslips from "../human-resources/payroll/send-payslips/hr-payroll-send-payslips";
import HrSalarySettings from "../human-resources/payroll/salary-settings/hr-salary-settings";
import HrGrossPayManagement from "../human-resources/payroll/gross-pay-management/hr-gross-pay-management";
import PermissionMenus from "../settings/permission/menus/permission-menu";
import PermissionGroup from "../settings/permission/group/permission-group";
import PermissionPermission from "../settings/permission/permission/permission-permission";
import AddStaffBank from "../human-resources/staff/add-staff-bank";
import AddStaffNOK from "../human-resources/staff/add-staff-nok";
import ModuleAssignment2 from "../academic/timetable-planner/module-assignment_2";
import LecturerAssignment from "../academic/timetable-planner/LecturerAssignment";
import FinanceSettings from "../human-resources/finance/finance-settings/finance-settings";
import AdmissionLetterSettings from "../human-resources/finance/admission-letter-settings/admission-letter-settings";
import PostPayment from "../human-resources/finance/post-payment/post-payment";
import PaymentReceipt from "../human-resources/finance/payment-receipt/payment-receipt";
import FinanceAllowRegistration from "../human-resources/finance/finance-allow-registration/finance-allow-registration";
import FinanceAllowResult from "../human-resources/finance/finance-allow-result/finance-allow-result";
import ViewTimeTableGrid from "../academic/timetable/timetable/timetable-view/timetable-grid";
import TimetableReport from "../academic/timetable/timetable-report/timetable";
import ManageTimetableSchedule from "../academic/timetable/manage-schedule/manage-schedule";
import ClashByPass from "../academic/timetable/clash-by-pass/clash-by-pass";
import SemesterRegistration from "../registration/semeter-registration/semester-registration";
import SemesterRegistrationApproval from "../registration/semeter-registration/semeter-registration-approval";
import SemesterRegistrationSettings from "../settings/registration-settings/registration-settings";
import OfficerAssignment from "../academic/timetable-planner/OfficerAssignment";
import DeanApproval from "../academic/timetable-planner/DeanApproval";
import FinalSubmission from "../academic/timetable-planner/FinalSubmission";
import SubmissionReport from "../academic/timetable-planner/SubmissionReport";
import EnrolmentList from "../human-resources/jobs/enrolment/enrolment-list";
import CASettings from "../assessments/assessment/ca-settings/ca-settings";
import CAEntry from "../assessments/assessment/ca-entry/ca-entry";
import ResetPassword from "../authentication/login/reset-password";
import StaffList from "../user/staff-report/staff-list";
import DeanList from "../user/staff-report/dean-list";
import HodList from "../user/staff-report/hod-list";
import StaffDistribution from "../user/staff-report/staff-distribution";
import StaffListByModule from "../user/staff-report/staff-list-by-module";
import NewStudentEnrolment from "../registration/student-manager/new-student-enrolment/new-student-enrolment";
import NewStudentEnrolmentDetails from "../registration/student-manager/reports/enrolment-details";
import NewStudentEnrolmentReport from "../registration/student-manager/reports/enrolment-report";
import CAFinalSubmission from "../assessments/assessment/final-submission/ca-final-submission";
import StaffListByDesignation from "../user/staff-report/staff-list-by-designation";
import ExamBarcode from "../assessments/exam/exam-barcode/exam-barcode";
import ExamGradeSettings from "../assessments/exam/grade-settings/exam-grade-settings";
import ExamTimeTableSchedule from "../assessments/exam/exam-timetable/timetable-schedule";
import ExamTimeTableHall from "../assessments/exam/exam-timetable/timetable-hall";
import ExamTimeTableReport from "../assessments/exam/exam-timetable/timetable-report";

import StaffListByModuleAndSemester from "../user/staff-report/staff-list-by-module-and-semester";
import StaffListByGoogleScholar from "../user/staff-report/staff-list-with-google-scholar";
import ExamCaEntry from "../assessments/assessment/ca-entry/exam-ca-entry";
import EXAMCAFinalSubmission from "../assessments/assessment/final-submission/exam-ca-final-submission";
import ProgressionStep from "../registration/progressions/progression-step/progression-step";

import Hostel from "../registration/hostel/Hostel/Hostel";
import HostelAllocations from "../registration/hostel/Hostel/HostelAllocations";
import HostelRooms from "../registration/hostel/Hostel/HostelRooms";
import HostelAllocationForm from "../registration/hostel/Hostel/HostelAllocationForm";
import ResetHostelRooms from "../registration/hostel/Hostel/ResetHostelRooms";

import TimeTableByBlock from "../academic/timetable/timetable-by-block/TimeTableByBlock";
import TimeTableByCourse from "../academic/timetable/timetable-by-block/TimeTableByCourse";
import ActiveStudentList from "../user/student-report/ActiveStudentList";
import ActiveStudentListByCourse from "../user/student-report/ActiveStudentListByCourse";
import ActiveStudentListByModeOfEntry from "../user/student-report/ActiveStudentListByModeOfEntry";
import ActiveStudentListByDepartment from "../user/student-report/ActiveStudentListByDepartment";

import StudentListByLecturerModule from "../user/student-report/StudentListByLecturerModule";
import SemesterProgression from "../registration/progressions/semester-progression/semester-progression";
import ProgressionHistory from "../registration/progressions/progression-history/progression-history";
import MissingRegistrationModule from "../registration/semeter-registration/missing-registration";
import ProcessRunningModules from "../academic/timetable-planner/process-running-modules";
import ChangeofCourseGuardian from "../registration/change-of-course/guardian-approval";
import ChangeOfCourseAdmissionOfficeApproval from "../registration/change-of-course/admission-approval";
import ChangeofCourseReport from "../registration/change-of-course/change-of-course-report";
import ChangeOfCourseRegistrarOfficeApproval from "../registration/change-of-course/registrar-approval";
import GuardianApprovalForm from "../registration/change-of-course/guardian-approval-form";
import EXAMSCASettings from "../assessments/assessment/ca-settings/exams-ca-settings";

import ProcessCA from "../assessments/assessment/process-ca/process-ca";
import DepartmentalModeration from "../assessments/moderation/departmental-moderation";
import CollegeModeration from "../assessments/moderation/college-moderation";
import SBCModeration from "../assessments/moderation/sbc-moderation";
import ModerationApproval from "../assessments/moderation/moderation-approval";
import DeanApprovalPage from "../assessments/moderation/dean-approval";
import SBCApprovalPage from "../assessments/moderation/sbc-approval";
import UniversityModeration from "../assessments/moderation/university-moderation";
import GenerateAttendance from "../assessments/attendance/attendance";
import AttendanceList from "../assessments/attendance/lecturer-mark-attendance";
import AttendanceReport from "../assessments/attendance/attendance-report";
import DITAttendanceReport from "../assessments/attendance/dit-attendance-report";
import DeanAttendanceReport from "../assessments/attendance/dean-attendance-report";
import HODAttendanceReport from "../assessments/attendance/hod-attendance-report";
import LecturerAttendanceReport from "../assessments/attendance/lecturer-attendance-report";
import UniversityAttendanceOverview from "../assessments/attendance/university-attendance-overview";
import FacultyAttendanceSummary from "../assessments/attendance/faculty-attendance-summary";
import DepartmentAttendanceSummary from "../assessments/attendance/department-attendance-summary";
import SendAttendanceEmail from "../assessments/attendance/send-attendance-email";
import ModuleAvgUniversity from "../assessments/attendance/module-avg-university";
import ModuleAvgFaculty from "../assessments/attendance/module-avg-faculty";
import ModuleAvgDepartment from "../assessments/attendance/module-avg-department";

import StudentListByCourseAll from "../user/student-report/student-list-by-course-all";
import StudentListAll from "../user/student-report/student-list-all";

import PostExamResult from "../assessments/exam/post-exam-result/post-exam-result";
import DefermentApplications from "../registration/deferment/deferment-application";
import ProcessResult from "../assessments/exam/process-result/process-result";
import ApproveResult from "../assessments/exam/approve-result/approve-result";
import GenerateIDCard from "../user/id-card/id-card";
import CaptureBiometric from "../user/biometric/biometric";
import AddStudentPortal from "../user/student-manager/add-student-portal/AddStudentPortal";
import ActivateNewStudents from "../user/student-manager/activate-new-students/ActivateNewStudents";
import LoginToStudentPortal from "../user/student-manager/login-to-student-portal/LoginToStudentPortal";
import StudentDeferment from "../registration/student-deferment/Deferment/StudentDeferment";
import StudentProfile from "../user/student-manager/student-profile/StudentProfile";
import UpdateStudentDetails from "../user/student-manager/update-student-details/UpdateStudentDetails";
import RegisteredStudentsCountByModule from "../registration/registration-report/registered-students-count-by-module";
import ActiveNotRegistered from "../registration/registration-report/active-not-registered";
import EditStaffProfile from "../user/staff-edit-profile/staff-edit-profile";
import LogComplain from "../user/service-desk/log-complain";
import ComplainList from "../user/service-desk/complain-list";
import MyComplains from "../user/service-desk/my-complains";
import PaidNotRegistered from "../registration/registration-report/paid-not-registered";
import RegisteredNotPaid from "../registration/registration-report/registered-not-paid";
import CarryOverNotRegistered from "../registration/registration-report/carry-over-not-registered";
import PublicationManager from "../user/publication-manager/publication-manager";

import StudentParticularProfile from "../user/student-manager/student-profile/StudentParticularProfile";
import ReturnList from "../registration/student-deferment/return-list/ReturnList";

import ComplainsAssignedToMe from "../user/service-desk/assigned-to-me";
import StudentDefermentReturn from "../registration/student-deferment/student-deferment-return/StudentDefermentReturn";
import DeleteResult from "../assessments/exam/delete-result/delete-result";
import ExaminationReports from "../assessments/reports/exams-reports";
import ResultActivityTracker from "../assessments/reports/result-activity-tracker";
import StaffLeaveSettings from "../human-resources/staff-leave/leave-settings";
import StaffLeaveCategoryMembers from "../human-resources/staff-leave/category-members";
import StaffLeaveApply from "../human-resources/staff-leave/leave-apply";
import StaffLeaveApplications from "../human-resources/staff-leave/leave-applications";
import AdmissionClearance from "../user/graduation-clearance/admission-clearance/AdmissionClearance";
import ExamClearance from "../user/graduation-clearance/exam-clearance/ExamClearance";
import LibraryClearance from "../user/graduation-clearance/library-clearance/LibraryClearance";
import FinanceClearance from "../user/graduation-clearance/finance-clearance/FinanceClearance";
import EvaluateGPA from "../assessments/assessment/evaluate-gpa/evaluate-gpa";
import ByCourse from "../academic/module-running/by-course";
import ByDepartment from "../academic/module-running/by-department";
import ByFaculty from "../academic/module-running/by-faculty";

import AllTranscriptApplications from "../registration/transcript-applications/all-transcript-applications/AllTranscriptApplications";
import PendingTranscriptApplications from "../registration/transcript-applications/pending-transcript-applications/PendingTranscriptApplications";

import ByUniversity from "../academic/module-running/by-university";
import InternshipManager from "../user/internship-manager/internship-manager";
import ModuleAssignment from "../academic/timetable-planner/module-assignment";
import AdmissionDateLine from "../registration/admissions/admission-dateline";
import InitiateClearance from "../user/graduation-clearance/initiate-clearance/InitiateClearance";
import AllPaymentReport from "../human-resources/finance-report/all-payment-report";
import CustomPaymentReport from "../human-resources/finance-report/custom-payment-report";
import PaymentReportByTrimester from "../human-resources/finance-report/payment-report-by-trimester";
import TuitionFeePaymentReport from "../human-resources/finance-report/tuition-fee-payment-report";
import FeedingPaymentReport from "../human-resources/finance-report/feeding-payment-report";
import HostelPaymentReport from "../human-resources/finance-report/hostel-payment-report";
import FeedingPaymentReportDateRange from "../human-resources/finance-report/feeding-payment-report-date-range";
import HostelPaymentReportDateRange from "../human-resources/finance-report/hostel-payment-report-date-range";
import StudentPaymentAnalysis from "../human-resources/finance-report/student-payment-analysis";
import ExamAttendanceSheet from "../assessments/reports/exam-attendance-sheet";
import GraduatingList from "../user/student-report/graduating-list";
import StudentsConstactByModule from "../user/student-report/students-contact-by-module";
import StudentsContactByLecturerModule from "../user/student-report/students-contact-by-lecturer-module";
import LastSemesterRegistered from "../user/student-report/last-semester-registered";
import JambReport from "../user/student-report/jamb-report";
import NumberOfStudentsPerModule from "../user/student-report/number-of-students-per-module";
import NumberOfStudentsPerProgram from "../user/student-report/number-of-students-per-program";
import StudentEnrolledByDepartment from "../user/student-report/student-enrolled-by-department";
import Inventory from "../human-resources/inventory/inventory";
import AcademicResultByCourse from "../assessments/academic-result/academic-result-by-course";
import AcademicResultByDepartment from "../assessments/academic-result/academic-result-by-department";
import AcademicResultByModule from "../assessments/academic-result/academic-result-by-module";
import AcademicResultByFaculty from "../assessments/academic-result/academic-result-by-faculty";
import TuitionFee from "../registration/admissions/tution-fees";

import InventorySettings from "../human-resources/inventory/inventory-settings/inventory-settings";
import LedgerBranch from "../human-resources/pension/ledger/ledger-branch";
import ledgerDocuments from "../human-resources/pension/ledger/ledger-documents";
import LedgerDocuments from "../human-resources/pension/ledger/ledger-documents";
import LedgerEntries from "../human-resources/pension/ledger/ledger-entry";
import InventoryDashboard from "../human-resources/inventory/inventory-dashboard/inventory-dashboard";
import ItemAllocation from "../human-resources/inventory/inventory-dashboard/item-allocation/item-allocation";
import InventoryReport from "../human-resources/inventory/inventory-dashboard/inventory-report";
import MarkExamBarcode from "../assessments/exam/mark-exam-barcode/mark-exam-barcode";
import UpdateStudentInformation from "../user/student-manager/update-student-information/update-student-information";
import UpdateStaffPassword from "../user/staff-report/update-staff-password";
import ComplainTypes from "../user/service-desk/complain-types";
import TimetableMigration from "../academic/timetable/timetable-migration/timetable-migration";
import AutoGenerateTimetable from "../academic/timetable/auto-generate/auto-generate";
import RegistrationClearanceReport
  from "../human-resources/finance/clearance-report/registration-clearance-report";
import ResultClearanceReport from "../human-resources/finance/clearance-report/result-clearance-report";
import InventoryManufacturer from "../human-resources/inventory/inventory-manufacturer/inventory-manufacturer";
import InventoryVendor from "../human-resources/inventory/inventory-vendor/inventory-vendor";
import InventoryLocation from "../human-resources/inventory/inventory-location/inventory-location";
import InventoryItem from "../human-resources/inventory/inventory-item/inventory-item";
import InventoryCategory from "../human-resources/inventory/inventory-category/inventory-category";
import InventoryTrackStock
  from "../human-resources/inventory/inventory-track-stock-movement/inventory-track-stock-movement";
import InventoryList from "../human-resources/inventory/inventory-list/inventory-list";
import InventoryPurchaseOrder from "../human-resources/inventory/inventory-purchase-order/inventory-purchase-order";
import InventoryAllocation from "../human-resources/inventory/inventory-allocation/inventory-allocate";
import FinanceAccount from "../human-resources/finance-and-budget/finance-account";
import FinanceTransaction from "../human-resources/finance-and-budget/finance-transaction";
import FinanceFinancialYear from "../human-resources/finance-and-budget/finance-financial-year";
import FinanceReportAccountsPayableAging
  from "../human-resources/finance-and-budget/finance-report-accounts-payable-aging";
import FinanceReportAccountReceivableAging
  from "../human-resources/finance-and-budget/finance-report-accounts-receivable-aging";
import FinanceReportBalanceSheet from "../human-resources/finance-and-budget/finance-report-balance-sheet";
import FinanceReportBankReconciliation from "../human-resources/finance-and-budget/finance-report-bank-reconciliation";
import FinanceReportGeneralLedger from "../human-resources/finance-and-budget/finance-report-general-ledger";
import FinanceReportIncomeStatement from "../human-resources/finance-and-budget/finance-report-income-statement";
import FinanceReportTrialBalance from "../human-resources/finance-and-budget/finance-report-trial-balance";
import AccountPayable from "../human-resources/inventory/inventory-account/account-payable"
import FinanceBudgetReport from "../human-resources/finance-and-budget/finance-budget-report";
import FinanceMyBudget from "../human-resources/finance-and-budget/finance-my-budget";
import FinanceBudgetProfile from "../human-resources/finance-and-budget/finance-budget-profile";
import GLChartOfAccounts from "../human-resources/general-ledger/gl-chart-of-accounts";
import GLJournalEntries from "../human-resources/general-ledger/gl-journal-entries";
import GLJournalDetail from "../human-resources/general-ledger/gl-journal-detail";
import GLFiscalPeriods from "../human-resources/general-ledger/gl-fiscal-periods";
import GLReportTrialBalance from "../human-resources/general-ledger/gl-report-trial-balance";
import GLReportAccountLedger from "../human-resources/general-ledger/gl-report-account-ledger";
import GLReportIncomeStatement from "../human-resources/general-ledger/gl-report-income-statement";
import GLReportBalanceSheet from "../human-resources/general-ledger/gl-report-balance-sheet";
import StaffActivity from "../human-resources/staff-activity/staff-activity";
import PostExamResultByLecturer from "../assessments/exam/post-exam-lecturer/post-exam-lecturer";
import AcademicResultSummaryByCourse from "../assessments/academic-result/academic-result-summary-by-course";
import CAEntryReport from "../assessments/assessment/ca-entry/ca-entries-report";
import CANotSubmitted from "../assessments/reports/ca-not-submitted";
import CASubmitted from "../assessments/reports/ca-submitted";
import CAAcknowledgementByCourse from "../assessments/reports/ca-acknowledgment-by-course";
import AcademicResultByUniversity from "../assessments/academic-result/academic-result-by-university";
import StudentResultSlip from "../assessments/reports/student-result-slip";
import ModuleResultSummary from "../assessments/reports/module-result-summary";
import ModuleIndividualResults from "../assessments/reports/module-individual-results";
import SemesterTranscript from "../assessments/reports/semester-transcript";
import CumulativeResultReport from "../assessments/reports/cumulative-result-report";
import SenateUniversity from "../assessments/reports/senate/senate-university";
import SenateFaculty from "../assessments/reports/senate/senate-faculty";
import SenateDepartment from "../assessments/reports/senate/senate-department";
import SenateCourse from "../assessments/reports/senate/senate-course";
import SenateModule from "../assessments/reports/senate/senate-module";
import ExamBulkUpload from "../assessments/exam/post-exam-lecturer/exam-bulk-upload";
import ExamResultBulkUpload from "../assessments/exam/post-exam-lecturer/exam-bulk-upload";
import BankReport from "../human-resources/salary-report/bank-report";
import PaySlip from "../human-resources/salary-report/pay-slip";
import PensionScheduleReport from "../human-resources/salary-report/pension-report";
import SalarySummaryReport from "../human-resources/salary-report/salary-summary-report";
import SalaryBreakdownReport from "../human-resources/salary-report/salary-breakdown-report";
import NSITFReport from "../human-resources/salary-report/nsitf-report";
import ITFReport from "../human-resources/salary-report/itf-report";
import HrSalarySchedule from "../human-resources/payroll/salary-schedule/hr-salary-schedule";

// AC-Finance Module Imports
import ACFinanceDashboard from "../human-resources/ac-finance/ac-finance-dashboard";
import FeeItems from "../human-resources/ac-finance/fee-items/fee-items";
import OtherFees from "../human-resources/ac-finance/other-fees/other-fees";
import FeeSchedules from "../human-resources/ac-finance/fee-schedules/fee-schedules";
import ScholarshipManagement from "../human-resources/ac-finance/scholarships/scholarship-management";
import InvoiceManagement from "../human-resources/ac-finance/invoices/invoice-management";
import CreateInvoice from "../human-resources/ac-finance/invoices/create-invoice";
import BalanceManagement from "../human-resources/ac-finance/balances/balance-management";
import StudentPaymentHistory from "../human-resources/ac-finance/payments/student-payment-history";
import PaymentByLevel from "../human-resources/finance/reports/payment-by-level";
import PaymentByProgramme from "../human-resources/finance/reports/payment-by-programme";
import PaymentByDepartment from "../human-resources/finance/reports/payment-by-department";
import PaymentByFaculty from "../human-resources/finance/reports/payment-by-faculty";
import OutstandingReport from "../human-resources/finance/reports/outstanding-report";
import BalanceReport from "../human-resources/finance/reports/balance-report";
import ScholarshipReport from "../human-resources/finance/reports/scholarship-report";
import ScholarshipStudentsReport from "../human-resources/finance/reports/scholarship-students-report";
import ActiveStudentsOutstanding from "../human-resources/finance/reports/active-students-outstanding";
import FinanceInvoiceManagement from "../human-resources/finance/invoices/invoice-management";
import FinanceCreateInvoice from "../human-resources/finance/invoices/create-invoice";
import InvoiceReport from "../human-resources/finance/invoices/invoice-report";
import FinancePaymentReport from "../human-resources/finance/invoices/payment-report";
import OutstandingBalanceReport from "../human-resources/finance/invoices/outstanding-balance-report";
import CollectionRegister from "../human-resources/finance/invoices/collection-register";
import DailyCollection from "../human-resources/finance/invoices/daily-collection";
import FeeTypeCollection from "../human-resources/finance/invoices/fee-type-collection";
import InstallmentReport from "../human-resources/finance/invoices/installment-report";
import InvoiceByFaculty from "../human-resources/finance/invoices/by-faculty";
import InvoiceByDepartment from "../human-resources/finance/invoices/by-department";
import InvoiceByCourse from "../human-resources/finance/invoices/by-course";
import OutstandingByFaculty from "../human-resources/finance/invoices/outstanding-by-faculty";
import OutstandingByDepartment from "../human-resources/finance/invoices/outstanding-by-department";
import OutstandingByCourse from "../human-resources/finance/invoices/outstanding-by-course";
import InstallmentByFaculty from "../human-resources/finance/invoices/installment-by-faculty";
import InstallmentByDepartment from "../human-resources/finance/invoices/installment-by-department";
import InstallmentByCourse from "../human-resources/finance/invoices/installment-by-course";
import UniversityWide from "../human-resources/finance/invoices/university-wide";

// Scholarship Module Imports
import ScholarshipDefinitions from "../human-resources/scholarship/scholarship-definitions";
import ScholarshipStudents from "../human-resources/scholarship/scholarship-students";
import ScholarshipAdmission from "../human-resources/scholarship/scholarship-admission";
import AcademicScholarships from "../human-resources/scholarship/academic-scholarships";
import ScholarshipUsage from "../human-resources/scholarship/scholarship-usage";
import ScholarshipReportNew from "../human-resources/scholarship/scholarship-report";

// Staff Appraisal Module Imports
import AppraisalSettings from "../human-resources/appraisal/settings/appraisal-settings";
import HodScoreSettings from "../human-resources/appraisal/settings/hod-score-settings";
import MyAppraisal from "../human-resources/appraisal/staff/my-appraisal";
import BasicDetailsForm from "../human-resources/appraisal/staff/basic-details-form";
import HodPendingEvaluations from "../human-resources/appraisal/hod/pending-evaluations";
import HodEvaluateStaff from "../human-resources/appraisal/hod/evaluate-staff";
import DeanPendingApprovals from "../human-resources/appraisal/dean/pending-approvals";
import DeanReviewAppraisal from "../human-resources/appraisal/dean/review-appraisal";
import RegistrarPendingApprovals from "../human-resources/appraisal/registrar/pending-approvals";
import RegistrarReviewAppraisal from "../human-resources/appraisal/registrar/review-appraisal";
import VcPendingApprovals from "../human-resources/appraisal/vc/pending-approvals";
import VcFinalReview from "../human-resources/appraisal/vc/final-review";
import AppraisalDashboard from "../human-resources/appraisal/reports/appraisal-dashboard";
import AcademicPositions from "../human-resources/appraisal/staff/academic-positions";
import AdminResponsibilities from "../human-resources/appraisal/staff/admin-responsibilities";
import Memberships from "../human-resources/appraisal/staff/memberships";
import Trainings from "../human-resources/appraisal/staff/trainings";
import CommunityService from "../human-resources/appraisal/staff/community-service";
import Contributions from "../human-resources/appraisal/staff/contributions";
import DutySchedule from "../human-resources/appraisal/staff/duty-schedule";
import ViewHodScore from "../human-resources/appraisal/staff/view-hod-score";

export default function PageRoutes() {
  return (
    <div className="d-flex flex-column flex-root">
      <div className="page d-flex flex-row flex-column-fluid">
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div
            id="kt_content_container"
            className="container-custom container-xxl d-flex flex-column-fluid"
          >
            <div
              className="content d-flex flex-row flex-row-fluid"
              id="kt_content"
            >
              <Routes>
                {/* Dashboard Redirect */}
                <Route exact path="/" element={<Dashboard />} />
                <Route path="/sample" element={<Sample />} />
                {/* General */}
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/reset-password/:slug"
                  element={<ResetPassword />}
                />
                {/* HR Routes */}
                <Route
                  path="/human-resources/add/staff"
                  element={<AddEditStaff />}
                />
                <Route
                  path="/human-resources/staff/profile/:staffId"
                  element={<StaffProfile />}
                />
                <Route
                  path="/human-resources/upload/staff/document"
                  element={<UploadStaffDocument />}
                />
                <Route
                  path="/human-resources/add/staff/qualifications"
                  element={<AddStaffQualifications />}
                />
                <Route
                  path="/human-resources/add/staff/pension/record"
                  element={<AddEditStaffPensionRecord />}
                />
                <Route
                  path="/human-resources/add/staff/bank"
                  element={<AddStaffBank />}
                />
                <Route
                  path="/human-resources/add/staff/nok"
                  element={<AddStaffNOK />}
                />
                <Route
                  path="/human-resources/staff-management/documents"
                  element={""}
                />
                <Route path="/human-resources/staff-management/documents" element={""} />
                <Route path="/human-resources/staff-management/photos" element={<UploadStaffPhoto />} />
                <Route path="/human-resources/staff-activity" element={<StaffActivity />} />
                {/*pension Routes*/}
                <Route path="/human-resources/pension/reports" element={""} />
                <Route
                  path="/human-resources/pension/post-pension-arrears"
                  element={""}
                />
                {/*Others*/}
                <Route
                  path="/human-resources/others/inventory"
                  element={<Inventory />}
                />
                <Route
                  path="/human-resources/others/banks"
                  element={<HRBank />}
                />
                <Route
                  path="/human-resources/others/qualifications"
                  element={<HRQualifications />}
                />
                <Route
                  path="/human-resources/others/designations"
                  element={<HRDesignations />}
                />
                <Route
                  path="/human-resources/others/title"
                  element={<HRTitle />}
                />
                <Route
                  path="/human-resources/others/qualifications"
                  element={<HRQualifications />}
                />
                <Route
                  path="/human-resources/others/designations"
                  element={<HRDesignations />}
                />
                <Route
                  path="/human-resources/others/nationality"
                  element={<HRNationality />}
                />
                <Route
                  path="/human-resources/pension/settings"
                  element={<HRPensionSettings />}
                />
                <Route
                  path="/human-resources/pension/administrators"
                  element={<HRPensionAdministrator />}
                />
                <Route
                  path="/human-resources/pension/report"
                  element={<HRPensionReport />}
                />
                <Route
                  path="/human-resources/pension/staff/enrolled"
                  element={<HRPensionStaffEnrolledReport />}
                />
                <Route
                  path="/human-resources/pension/staff/not-enrolled"
                  element={<HRPensionStaffNotEnrolledReport />}
                />
                <Route
                  path="/human-resources/payroll/salary-settings"
                  element={<HrSalarySettings />}
                />
                <Route
                  path="/human-resources/payroll/general-ledger"
                  element={<HRGeneralLedger />}
                />
                <Route
                  path="/human-resources/payroll/manage-allowance-and-deduction"
                  element={<HRPayrollManageAllowanceAndDeduction />}
                />
                <Route
                  path="/human-resources/payroll/run-allowance-and-deduction"
                  element={<HRPayrollRunAllowanceAndDeduction />}
                />
                <Route
                  path="/human-resources/payroll/post-schedule"
                  element={<HrPayrollPostSchedule />}
                />
                <Route
                  path="/human-resources/payroll/send-payslips"
                  element={<HrPayrollSendPayslips />}
                />
                <Route
                  path="/human-resources/payroll/gross-pay-management"
                  element={<HrGrossPayManagement />}
                />
                <Route
                  path="/human-resources/payroll/salary-schedule"
                  element={<HrSalarySchedule />}
                />
                <Route
                  path="/human-resources/finance-report/all-payment"
                  element={<AllPaymentReport />}
                />
                <Route
                  path="/human-resources/finance-report/custom-payment-report"
                  element={<CustomPaymentReport />}
                />
                <Route
                  path="/human-resources/finance-report/payment-report-by-trimester"
                  element={<PaymentReportByTrimester />}
                />
                <Route
                  path="/human-resources/finance-report/tuition-fee-payment-report"
                  element={<TuitionFeePaymentReport />}
                />
                <Route
                  path="/human-resources/finance-report/feeding-payment-report"
                  element={<FeedingPaymentReport />}
                />
                <Route
                  path="/human-resources/finance-report/hostel-payment-report"
                  element={<HostelPaymentReport />}
                />
                <Route
                  path="/human-resources/finance-report/feeding-payment-report-date-range"
                  element={<FeedingPaymentReportDateRange />}
                />
                <Route
                  path="/human-resources/finance-report/hostel-payment-report-date-range"
                  element={<HostelPaymentReportDateRange />}
                />
                <Route
                  path="/human-resources/finance-report/student-payment-analysis"
                  element={<StudentPaymentAnalysis />}
                />
                {/* jobs routes */}
                <Route
                  path="/human-resources/jobs/openings"
                  element={<JobOpenings />}
                />
                <Route
                  path="/human-resources/jobs/applications"
                  element={<JobApplications />}
                />
                <Route
                  path="/human-resources/jobs/applications/:id"
                  element={<JobApplicationDetails />}
                />
                <Route
                  path="/human-resources/jobs/enrolment"
                  element={<EnrolmentList />}
                />

                <Route
                  path="/human-resources/staff-leave/settings"
                  element={<StaffLeaveSettings />}
                />
                <Route
                  path="/human-resources/staff-leave/category-members"
                  element={<StaffLeaveCategoryMembers />}
                />
                <Route
                  path="/human-resources/staff-leave/apply"
                  element={<StaffLeaveApply />}
                />
                <Route
                  path="/human-resources/staff-leave/applications"
                  element={<StaffLeaveApplications />}
                />

                {/* Staff Appraisal Routes */}
                <Route path="/human-resources/appraisal/settings" element={<AppraisalSettings />} />
                <Route path="/human-resources/appraisal/hod-score-settings" element={<HodScoreSettings />} />
                <Route path="/human-resources/appraisal/my-appraisal" element={<MyAppraisal />} />
                <Route path="/human-resources/appraisal/basic-details" element={<BasicDetailsForm />} />
                <Route path="/human-resources/appraisal/basic-details/:appraisalId" element={<BasicDetailsForm />} />
                <Route path="/human-resources/appraisal/hod/pending" element={<HodPendingEvaluations />} />
                <Route path="/human-resources/appraisal/hod/evaluate/:appraisalId" element={<HodEvaluateStaff />} />
                <Route path="/human-resources/appraisal/dean/pending" element={<DeanPendingApprovals />} />
                <Route path="/human-resources/appraisal/dean/review/:appraisalId" element={<DeanReviewAppraisal />} />
                <Route path="/human-resources/appraisal/registrar/pending" element={<RegistrarPendingApprovals />} />
                <Route path="/human-resources/appraisal/registrar/review/:appraisalId" element={<RegistrarReviewAppraisal />} />
                <Route path="/human-resources/appraisal/vc/pending" element={<VcPendingApprovals />} />
                <Route path="/human-resources/appraisal/vc/review/:appraisalId" element={<VcFinalReview />} />
                <Route path="/human-resources/appraisal/dashboard" element={<AppraisalDashboard />} />
                <Route path="/human-resources/appraisal/academic-positions/:appraisalId" element={<AcademicPositions />} />
                <Route path="/human-resources/appraisal/admin-responsibilities/:appraisalId" element={<AdminResponsibilities />} />
                <Route path="/human-resources/appraisal/memberships/:appraisalId" element={<Memberships />} />
                <Route path="/human-resources/appraisal/trainings/:appraisalId" element={<Trainings />} />
                <Route path="/human-resources/appraisal/community-service/:appraisalId" element={<CommunityService />} />
                <Route path="/human-resources/appraisal/contributions/:appraisalId" element={<Contributions />} />
                <Route path="/human-resources/appraisal/duty-schedule/:appraisalId" element={<DutySchedule />} />
                <Route path="/human-resources/appraisal/view-hod-score" element={<ViewHodScore />} />

                {/*academics*/}
                <Route path="/academics/faculty" element={<Faculty />} />
                <Route path="/academics/department" element={<Department />} />
                <Route path="/academics/modules" element={<Modules />} />
                <Route
                  path="/academics/timetable/settings"
                  element={<TimetableSettings />}
                />
                <Route
                  path="/academics/timetable/add-schedule"
                  element={<ManageTimetableSchedule />}
                />
                <Route
                  path="/academics/timetable/update-schedule/:slug"
                  element={<ManageTimetableSchedule />}
                />
                <Route
                  path="/academics/timetable/student-group"
                  element={<TimetableStudentGroup />}
                />
                <Route
                  path="/academics/timetable/semester"
                  element={<TimetableSemester />}
                />
                <Route
                  path="/academics/timetable/view"
                  element={<ViewTimeTableGrid />}
                />
                <Route
                  path="/academics/timetable/view"
                  element={<ViewTimeTableGrid />}
                />
                <Route
                  path="/academics/timetable/timetable-report"
                  element={<TimetableReport />}
                />
                <Route
                  path="/academics/timetable/timetable-migration"
                  element={<TimetableMigration />}
                />
                <Route
                  path="/academics/timetable/timetable-by-block"
                  element={<TimeTableByBlock />}
                />
                <Route
                  path="/academics/timetable/timetable-by-course"
                  element={<TimeTableByCourse />}
                />
                <Route
                  path="/academics/timetable/module-clash"
                  element={<ClashByPass />}
                />
                <Route
                  path="/academics/timetable/auto-generate"
                  element={<AutoGenerateTimetable />}
                />
                <Route
                  path="/academics/module-running/by-course"
                  element={<ByCourse />}
                />
                <Route
                  path="/academics/module-running/by-department"
                  element={<ByDepartment />}
                />
                <Route
                  path="/academics/module-running/by-faculty"
                  element={<ByFaculty />}
                />
                <Route
                  path="/academics/module-running/by-university"
                  element={<ByUniversity />}
                />
                <Route path="/academics/courses" element={<Course />} />
                <Route
                  path="/assessment/exam-timetable/schedule"
                  element={<ExamTimeTableSchedule />}
                />
                <Route
                  path="/assessment/exam-timetable/schedule-venue"
                  element={<ExamTimeTableHall />}
                />

                <Route
                  path="/assessment/examinations/reports"
                  element={<ExaminationReports />}
                />

                <Route
                  path="/assessment/exam-attendance-sheet"
                  element={<ExamAttendanceSheet />}
                />

                <Route
                  path="/assessment/exam-timetable/report"
                  element={<ExamTimeTableReport />}
                />

                <Route path="/assessment/academic-result/course" element={<AcademicResultByCourse />} />
                <Route path="/assessment/academic-result/department" element={<AcademicResultByDepartment />} />
                <Route path="/assessment/academic-result/faculty" element={<AcademicResultByFaculty />} />
                <Route path="/assessment/academic-result/module" element={<AcademicResultByModule />} />
                <Route path="/assessment/academic-result/university" element={<AcademicResultByUniversity />} />
                <Route path="/assessment/academic-result-summary/course" element={<AcademicResultSummaryByCourse />} />
                <Route path="/assessment/report/ca-not-submitted" element={<CANotSubmitted />} />
                <Route path="/assessment/report/ca-submitted" element={<CASubmitted />} />
                <Route path="/assessment/report/ca-summary-print-by-course" element={<CAAcknowledgementByCourse />} />
                <Route path="/assessment/report/ca-summary-print" element={<CAAcknowledgementByCourse />} />
                <Route path="/assessment/report/student-result-slip" element={<StudentResultSlip />} />
                <Route path="/assessment/report/module-result-summary" element={<ModuleResultSummary />} />
                <Route path="/assessment/report/module-individual-results" element={<ModuleIndividualResults />} />
                <Route path="/assessment/report/semester-transcript" element={<SemesterTranscript />} />
                <Route path="/assessment/report/cumulative-results" element={<CumulativeResultReport />} />

                {/* Senate Result Reports */}
                <Route path="/assessment/senate-report/university" element={<SenateUniversity />} />
                <Route path="/assessment/senate-report/faculty" element={<SenateFaculty />} />
                <Route path="/assessment/senate-report/department" element={<SenateDepartment />} />
                <Route path="/assessment/senate-report/course" element={<SenateCourse />} />
                <Route path="/assessment/senate-report/module" element={<SenateModule />} />

                <Route path="/academics/exam-timetable" element={""} />
                <Route
                  path="/academics/exam-timetable/schedule"
                  element={<ExamTimeTableSchedule />}
                />
                <Route
                  path="/academics/exam-timetable/schedule-venue"
                  element={<ExamTimeTableHall />}
                />
                <Route
                  path="/academics/exam-timetable/report"
                  element={<ExamTimeTableReport />}
                />
                <Route
                  path="/application-processing-ug/:applicant"
                  element={<ProcessApplication />}
                />
                <Route
                  path="/application-processing-pg/:applicant"
                  element={<ProcessApplicationPg />}
                />
                <Route
                  path="/registration/admissions"
                  element={<RegistrationDashboard />}
                />
                <Route path="/registration/admissions/tuition-fees" element={<TuitionFee />} />
                <Route
                  path="/registration/admissions/supporting-document"
                  element={<SupportingDocument />}
                />
                <Route
                  path="/registration/admissions/admission-dateline"
                  element={<AdmissionDateLine />}
                />
                <Route
                  path="/registration/admissions/edit-applicant/:id"
                  element={<EditApplicant />}
                />
                {/* regisration report */}
                <Route
                  path="/registration/registration-report/registered-students-count-by-module"
                  element={<RegisteredStudentsCountByModule />}
                />
                <Route
                  path="/registration/registration-report/active-not-registered"
                  element={<ActiveNotRegistered />}
                />
                <Route
                  path="/registration/registration-report/paid-not-registered"
                  element={<PaidNotRegistered />}
                />
                <Route
                  path="/registration/registration-report/registered-not-paid"
                  element={<RegisteredNotPaid />}
                />
                <Route
                  path="/registration/registration-report/carry-over-not-registered"
                  element={<CarryOverNotRegistered />}
                />

                <Route
                  path="/registration/progressions/progression-steps"
                  element={<ProgressionStep />}
                />

                <Route
                  path="/registration/progression/semester-progression"
                  element={<SemesterProgression />}
                />
                <Route
                  path="/registration/progression/progression-history"
                  element={<ProgressionHistory />}
                />
                <Route
                  path="/registration/registration/missing-registration-module"
                  element={<MissingRegistrationModule />}
                />

                {/* Hostel Module Routes    */}

                <Route
                  path="/registration/progression/semester-progression"
                  element={<SemesterProgression />}
                />

                {/* Hostel Module Routes    */}

                <Route
                  path="/registration/progression/semester-progression"
                  element={<SemesterProgression />}
                />

                <Route
                  path="/registration/hostel/hostels"
                  element={<Hostel />}
                />

                <Route
                  path="/registration/hostel/hostel-rooms"
                  element={<HostelRooms />}
                />
                <Route
                  path="/registration/hostel/hostel-allocations"
                  element={<HostelAllocations />}
                />
                <Route
                  path="/registration/hostel/hostel-allocation-form"
                  element={<HostelAllocationForm />}
                />
                <Route
                  path="/registration/hostel/reset-hostel-rooms"
                  element={<ResetHostelRooms />}
                />

                {/* Hostel Module Routes    */}

                {/* Users-> Student Manager Routes */}
                <Route
                  path="/users/student-manager/add-student-portal"
                  element={<AddStudentPortal />}
                />
                <Route
                  path="/users/student-manager/activate-new-students"
                  element={<ActivateNewStudents />}
                />

                <Route
                  path="/users/student-manager/login-to-student-portal"
                  element={<LoginToStudentPortal />}
                />
                <Route
                  path="/registration/student-deferment/deferment"
                  element={<StudentDeferment />}
                />
                <Route
                  path="/registration/student-deferment/student-deferment-return"
                  element={<StudentDefermentReturn />}
                />

                <Route
                  path="/registration/student-deferment/return-list"
                  element={<ReturnList />}
                />
                <Route
                  path="/users/student-manager/student-profile"
                  element={<StudentProfile />}
                />
                <Route
                  path="/users/student-manager/student-profile/:id"
                  element={<StudentParticularProfile />}
                />
                <Route
                  path="/users/student-manager/update-student-details"
                  element={<UpdateStudentDetails />}
                />

                <Route
                  path="/users/student-manager/update-student-information"
                  element={<UpdateStudentInformation />}
                />

                <Route
                  path="/users/student-manager/student-photos"
                  element={<UploadStudentPhoto />}
                />

                <Route
                  path="/users/staff-report/update-staff-password"
                  element={<UpdateStaffPassword />}
                />

                <Route
                  path="/users/internship-manager"
                  element={<InternshipManager />}
                />

                {/* Users-> Student Manager Routes */}

                {/* Graduation Clearance Module Start */}
                <Route
                  path="/users/graduation-clearance/admission-clearance"
                  element={<AdmissionClearance />}
                />
                <Route
                  path="/users/graduation-clearance/exams-clearance"
                  element={<ExamClearance />}
                />
                <Route
                  path="/users/graduation-clearance/library-clearance"
                  element={<LibraryClearance />}
                />
                <Route
                  path="/users/graduation-clearance/finance-clearance"
                  element={<FinanceClearance />}
                />
                <Route
                  path="/users/graduation-clearance/initiate-clearance"
                  element={<InitiateClearance />}
                />

                {/* Graduation Clearance Module End    */}

                {/* Transcript Module Start    */}
                <Route
                  path="/registration/transcript-applications/all-transcript-applications"
                  element={<AllTranscriptApplications />}
                />
                <Route
                  path="/registration/transcript-applications/pending-transcript-applications"
                  element={<PendingTranscriptApplications />}
                />
                {/* Transcript Module End    */}

                {/* Finance  */}
                <Route
                  path="/human-resources/finance/finance-settings"
                  element={<FinanceSettings />}
                />
                <Route
                  path="/human-resources/finance/admission-letter-settings"
                  element={<AdmissionLetterSettings />}
                />
                <Route
                  path="/human-resources/finance/post-payment"
                  element={<PostPayment />}
                />
                <Route
                  path="/human-resources/finance/payment-receipt/:slug"
                  element={<PaymentReceipt />}
                />
                <Route
                  path="/human-resources/finance/allow-student-registration"
                  element={<FinanceAllowRegistration />}
                />
                <Route
                  path="/human-resources/finance/allow-student-result"
                  element={<FinanceAllowResult />}
                />
                <Route path="/human-resources/finance-and-budget/account" element={<FinanceAccount />} />
                <Route path="/human-resources/finance-and-budget/transaction" element={<FinanceTransaction />} />
                <Route path="/human-resources/finance-and-budget/financial-year" element={<FinanceFinancialYear />} />
                <Route path="/human-resources/finance-and-budget/accounts-payable-aging-report" element={<FinanceReportAccountsPayableAging />} />
                <Route path="/human-resources/finance-and-budget/accounts-receivable-aging-report" element={<FinanceReportAccountReceivableAging />} />
                <Route path="/human-resources/finance-and-budget/balance-sheet-report" element={<FinanceReportBalanceSheet />} />
                <Route path="/human-resources/finance-and-budget/bank-reconciliation-report" element={<FinanceReportBankReconciliation />} />
                <Route path="/human-resources/finance-and-budget/finance-general-ledger-report" element={<FinanceReportGeneralLedger />} />
                <Route path="/human-resources/finance-and-budget/income-statement-report" element={<FinanceReportIncomeStatement />} />
                <Route path="/human-resources/finance-and-budget/trial-balance-report" element={<FinanceReportTrialBalance />} />
                <Route path="/human-resources/finance-and-budget/budget-report" element={<FinanceBudgetReport />} />
                <Route path="/human-resources/finance-and-budget/my-budget" element={<FinanceMyBudget />} />
                <Route path="/human-resources/finance-and-budget/budget-profile" element={<FinanceBudgetProfile />} />

                {/* General Ledger */}
                <Route path="/human-resources/general-ledger/chart-of-accounts" element={<GLChartOfAccounts />} />
                <Route path="/human-resources/general-ledger/journal-entries" element={<GLJournalEntries />} />
                <Route path="/human-resources/general-ledger/journal-detail/:id" element={<GLJournalDetail />} />
                <Route path="/human-resources/general-ledger/fiscal-periods" element={<GLFiscalPeriods />} />
                <Route path="/human-resources/general-ledger/trial-balance" element={<GLReportTrialBalance />} />
                <Route path="/human-resources/general-ledger/account-ledger/:id" element={<GLReportAccountLedger />} />
                <Route path="/human-resources/general-ledger/income-statement" element={<GLReportIncomeStatement />} />
                <Route path="/human-resources/general-ledger/balance-sheet" element={<GLReportBalanceSheet />} />

                <Route path="/registration/registration/semester-registration" element={<SemesterRegistration />} />
                <Route path="/registration/registration/approve-semester-registration" element={<SemesterRegistrationApproval />} />
                {/* timetable planner */}
                <Route
                  path="/academics/timetable-planner/module-assignment"
                  element={<ModuleAssignment />}
                />
                <Route
                  path="/academics/timetable-planner/module-assignment2"
                  element={<ModuleAssignment2 />}
                />
                <Route
                  path="/academics/timetable-planner/lecturer-assignment"
                  element={<LecturerAssignment />}
                />
                <Route
                  path="/academics/timetable-planner/officer-assignment"
                  element={<OfficerAssignment />}
                />
                <Route
                  path="/academics/timetable-planner/dean-approval"
                  element={<DeanApproval />}
                />
                <Route
                  path="/academics/timetable-planner/final-submission"
                  element={<FinalSubmission />}
                />
                <Route
                  path="/academics/timetable-planner/submission-report"
                  element={<SubmissionReport />}
                />
                <Route
                  path="/academics/timetable-planner/process-running-modules"
                  element={<ProcessRunningModules />}
                />
                {/*Student Manager*/}
                <Route
                  path="/registration/student-manager/enrolment"
                  element={<NewStudentEnrolment />}
                />
                <Route
                  path="/registration/student-manager/enrolment/report"
                  element={<NewStudentEnrolmentReport />}
                />
                <Route
                  path="/registration/student-manager/enrolment/:id"
                  element={<NewStudentEnrolmentDetails />}
                />
                <Route
                  path="/registration/registration/deferment/applications"
                  element={<DefermentApplications />}
                />
                {/*SETTINGS*/}
                <Route
                  path="/settings/permission/menus"
                  element={<PermissionMenus />}
                />
                <Route
                  path="/settings/permission/group"
                  element={<PermissionGroup />}
                />
                <Route
                  path="/settings/permission/permission"
                  element={<PermissionPermission />}
                />
                <Route
                  path="/settings/registration/settings"
                  element={<SemesterRegistrationSettings />}
                />

                <Route
                  path="/assessments/continuous-assessment/settings"
                  element={<CASettings />}
                />
                <Route
                  path="/assessments/continuous-assessment/exams/settings"
                  element={<EXAMSCASettings />}
                />

                <Route
                  path="/assessments/continuous-assessment/process/ca"
                  element={<ProcessCA />}
                />

                {/* Moderation Routes */}
                <Route
                  path="/assessments/moderation/departmental"
                  element={<DepartmentalModeration />}
                />
                <Route
                  path="/assessments/moderation/college"
                  element={<CollegeModeration />}
                />
                <Route
                  path="/assessments/moderation/sbc"
                  element={<SBCModeration />}
                />
                <Route
                  path="/assessments/moderation/approval"
                  element={<ModerationApproval />}
                />
                <Route
                  path="/assessments/moderation/dean-approval"
                  element={<DeanApprovalPage />}
                />
                <Route
                  path="/assessments/moderation/sbc-approval"
                  element={<SBCApprovalPage />}
                />
                <Route
                  path="/assessments/moderation/university"
                  element={<UniversityModeration />}
                />

                <Route
                  path="/assessments/continuous-assessment/entry"
                  element={<CAEntry />}
                />

                <Route
                  path="/assessments/continuous-assessment/entry-report"
                  element={<CAEntryReport />}
                />

                <Route
                  path="/assessments/continuous-assessment/final/submission/"
                  element={<CAFinalSubmission />}
                />

                <Route
                  path="/assessments/continuous-assessment/exam/mark/ca/"
                  element={<ExamCaEntry />}
                />

                <Route
                  path="/assessments/continuous-assessment/exam/final/ca/submission/"
                  element={<EXAMCAFinalSubmission />}
                />

                <Route
                  path="/assessments/exam/exam-barcode"
                  element={<ExamBarcode />}
                />

                <Route
                  path="/assessments/exam/mark-exam-barcode"
                  element={<MarkExamBarcode />}
                />

                <Route
                  path="/assessments/exam/grade-settings"
                  element={<ExamGradeSettings />}
                />

                <Route
                  path="/assessments/exam/post-exam-result-barcode"
                  element={<PostExamResult />}
                />
                <Route
                  path="/assessments/exam/post-exam-result-default"
                  element={<PostExamResult />}
                />
                <Route
                  path="/assessments/exam/post-exam-result-lecturer-default"
                  element={<PostExamResultByLecturer />}
                />
                <Route
                  path="/assessments/exam/bulk-upload"
                  element={<ExamResultBulkUpload />}
                />
                <Route
                  path="/assessments/exam/update-result"
                  element={<PostExamResult />}
                />
                <Route
                  path="/assessments/exam/process-result"
                  element={<ProcessResult />}
                />
                <Route
                  path="/assessments/exam/approve-result"
                  element={<ApproveResult />}
                />
                <Route
                  path="/assessments/exam/delete-result"
                  element={<DeleteResult />}
                />
                <Route
                  path="/assessments/exam/report/activity-tracker"
                  element={<ResultActivityTracker />}
                />
                <Route
                  path="/assessments/exam/approve-result"
                  element={<ApproveResult />}
                />
                <Route
                  path="/assessments/exam/delete-result"
                  element={<DeleteResult />}
                />
                <Route
                  path="/assessments/exam/report/activity-tracker"
                  element={<ResultActivityTracker />}
                />
                <Route
                  path="/assessments/exam/approve-result"
                  element={<ApproveResult />}
                />
                <Route
                  path="/assessments/exam/delete-result"
                  element={<DeleteResult />}
                />

                <Route
                  path="/assessments/attendance"
                  element={<GenerateAttendance />}
                />
                <Route
                  path="/assessments/attendance/list"
                  element={<AttendanceList />}
                />
                <Route
                  path="/assessments/attendance/report"
                  element={<AttendanceReport />}
                />
                <Route
                  path="/assessments/attendance/dit-report"
                  element={<DITAttendanceReport />}
                />
                <Route
                  path="/assessments/attendance/dean-report"
                  element={<DeanAttendanceReport />}
                />
                <Route
                  path="/assessments/attendance/hod-report"
                  element={<HODAttendanceReport />}
                />
                <Route
                  path="/assessments/attendance/lecturer-report"
                  element={<LecturerAttendanceReport />}
                />
                <Route
                  path="/assessments/attendance/university-overview"
                  element={<UniversityAttendanceOverview />}
                />
                <Route
                  path="/assessments/attendance/faculty-summary"
                  element={<FacultyAttendanceSummary />}
                />
                <Route
                  path="/assessments/attendance/department-summary"
                  element={<DepartmentAttendanceSummary />}
                />
                <Route
                  path="/assessments/attendance/send-email"
                  element={<SendAttendanceEmail />}
                />
                <Route
                  path="/assessments/attendance/module-avg-university"
                  element={<ModuleAvgUniversity />}
                />
                <Route
                  path="/assessments/attendance/module-avg-faculty"
                  element={<ModuleAvgFaculty />}
                />
                <Route
                  path="/assessments/attendance/module-avg-department"
                  element={<ModuleAvgDepartment />}
                />

                <Route
                  path="/assessments/evaluate/gpa"
                  element={<EvaluateGPA />}
                />

                {/*Users Reports*/}
                <Route
                  path="/users/staff-report/staff-list"
                  element={<StaffList />}
                />
                <Route
                  path="/users/staff-report/dean-list"
                  element={<DeanList />}
                />

                <Route
                  path="/users/staff-report/hod-list"
                  element={<HodList />}
                />
                <Route
                  path="/users/staff-report/staff-distribution"
                  element={<StaffDistribution />}
                />
                <Route
                  path="/users/staff-report/staff-list-by-module"
                  element={<StaffListByModule />}
                />
                <Route
                  path="/users/staff-report/staff-list-by-designation"
                  element={<StaffListByDesignation />}
                />
                <Route
                  path="/users/staff-report/staff-list-by-module-and-semester"
                  element={<StaffListByModuleAndSemester />}
                />
                <Route
                  path="/users/staff-report/staff-list-by-google-scholar"
                  element={<StaffListByGoogleScholar />}
                />
                <Route
                  path="/users/student-report/active-student-list"
                  element={<ActiveStudentList />}
                />
                <Route
                  path="/users/student-report/active-student-list-by-course"
                  element={<ActiveStudentListByCourse />}
                />
                <Route
                  path="/users/student-report/active-student-list-by-mode-of-entry"
                  element={<ActiveStudentListByModeOfEntry />}
                />
                <Route
                  path="/users/student-report/active-student-list-by-department"
                  element={<ActiveStudentListByDepartment />}
                />
                <Route
                  path="/users/student-report/student-list-by-lecturer-module"
                  element={<StudentListByLecturerModule />}
                />
                <Route
                  path="/users/student-report/student-list-by-course-all"
                  element={<StudentListByCourseAll />}
                />
                <Route
                  path="/users/student-report/student-list-all"
                  element={<StudentListAll />}
                />
                <Route
                  path="/users/student-report/graduating-list"
                  element={<GraduatingList />}
                />
                <Route
                  path="/users/student-report/students-contact-by-module"
                  element={<StudentsConstactByModule />}
                />
                <Route
                  path="/users/student-report/students-contact-by-lecturer-module"
                  element={<StudentsContactByLecturerModule />}
                />
                <Route
                  path="/users/student-report/last-semester-registered"
                  element={<LastSemesterRegistered />}
                />
                <Route
                  path="/users/student-report/jamb-report"
                  element={<JambReport />}
                />
                <Route
                  path="/users/student-report/number-of-students-per-module"
                  element={<NumberOfStudentsPerModule />}
                />
                <Route
                  path="/users/student-report/number-of-students-per-program"
                  element={<NumberOfStudentsPerProgram />}
                />
                <Route
                  path="/users/student-report/students-enrolled-by-department"
                  element={<StudentEnrolledByDepartment />}
                />
                <Route
                  path="/users/generate/id/card"
                  element={<GenerateIDCard />}
                />

                <Route
                  path="/users/capture/biometric"
                  element={<CaptureBiometric />}
                />

                <Route
                  path="/users/change-of-course/guardian"
                  element={<ChangeofCourseGuardian />}
                />
                <Route
                  path="/users/change-of-course/admission"
                  element={<ChangeOfCourseAdmissionOfficeApproval />}
                />
                <Route
                  path="/users/change-of-course/report"
                  element={<ChangeofCourseReport />}
                />
                <Route
                  path="/users/change-of-course/registrar"
                  element={<ChangeOfCourseRegistrarOfficeApproval />}
                />

                <Route
                  path="/users/edit-staff-profile"
                  element={<EditStaffProfile />}
                />

                <Route
                  path="/change-of-course/guardian-approve/:id"
                  element={<GuardianApprovalForm />}
                />

                {/*Publication Manager*/}
                <Route
                  path="/users/publication-manager"
                  element={<PublicationManager />}
                />

                <Route
                  path="/users/service-desk/log-complain"
                  element={<LogComplain />}
                />
                <Route
                  path="/users/service-desk/complain-types"
                  element={<ComplainTypes />}
                />
                <Route
                  path="/users/service-desk/complain-list"
                  element={<ComplainList />}
                />
                <Route
                  path="/users/service-desk/my-complains"
                  element={<MyComplains />}
                />
                <Route
                  path="/users/service-desk/assigned-complains"
                  element={<ComplainsAssignedToMe />}
                />
                <Route
                  path="/users/publication-manager"
                  element={<PublicationManager />}
                />

                {/*Inventory*/}


                <Route
                  path="human-resources/finance/registration-clearance-report"
                  element={<RegistrationClearanceReport />}
                />
                <Route
                  path="human-resources/finance/result-clearance-report"
                  element={<ResultClearanceReport />}
                />

                <Route path="/human-resources/inventory/inventory-settings" element={<InventorySettings />} />
                <Route path="/human-resources/inventory/dashboard" element={<InventoryDashboard />} />
                <Route path="/human-resources/inventory/item/allocation/:slug" element={<ItemAllocation />} />
                <Route path="/human-resources/inventory/item/report/:slug" element={<InventoryReport />} />
                {/*//11-March-2023 -- ahmad*/}
                <Route path="/human-resources/payroll/ledger-branch" element={<LedgerBranch />} />
                <Route path="/human-resources/payroll/ledger-documents" element={<LedgerDocuments />} />
                <Route path="/human-resources/payroll/ledger-entries" element={<LedgerEntries />} />

                {/*begin::Inventory*/}
                <Route exact path={"/human-resources/inventory/inventory-list"} element={<InventoryList />} />
                {/*  <Route exact path={"/human-resources/inventory/receive-inventory"} element={<InventoryReceiveItem />} />*/}
                <Route exact path={"/human-resources/inventory/track-stock-movements"} element={<InventoryTrackStock />} />
                <Route exact path={"/human-resources/inventory/inventory-item"} element={<InventoryItem />} />
                <Route exact path={"/human-resources/inventory/manufacturer"} element={<InventoryManufacturer />} />
                <Route exact path={"/human-resources/inventory/vendor"} element={<InventoryVendor />} />
                <Route exact path={"/human-resources/inventory/category"} element={<InventoryCategory />} />
                <Route exact path={"/human-resources/inventory/location"} element={<InventoryLocation />} />
                <Route exact path={"/human-resources/inventory/allocate"} element={<InventoryAllocation />} />
                <Route exact path={"/human-resources/inventory/generate-purchase-order"} element={<InventoryPurchaseOrder />} />
                <Route exact path={"/human-resources/inventory/finance"} element={<AccountPayable />} />
                {/*end::Inventory*/}


                <Route path="/human-resources/salary-report/bank-report" element={<BankReport />} />
                <Route path="/human-resources/salary-report/pay-slip" element={<PaySlip />} />
                <Route path="/human-resources/salary-report/pension-report" element={<PensionScheduleReport />} />
                <Route path="/human-resources/salary-report/salary-summary" element={<SalarySummaryReport />} />
                <Route path="/human-resources/salary-report/salary-breakdown" element={<SalaryBreakdownReport />} />
                <Route path="/human-resources/salary-report/nsitf-report" element={<NSITFReport />} />
                <Route path="/human-resources/salary-report/itf-report" element={<ITFReport />} />

                {/* AC-Finance Module Routes */}
                <Route path="/human-resources/ac-finance/dashboard" element={<ACFinanceDashboard />} />
                <Route path="/human-resources/ac-finance/fee-items" element={<FeeItems />} />
                <Route path="/human-resources/ac-finance/other-fees" element={<OtherFees />} />
                <Route path="/human-resources/ac-finance/fee-schedules" element={<FeeSchedules />} />
                <Route path="/human-resources/ac-finance/scholarships" element={<ScholarshipManagement />} />
                <Route path="/human-resources/ac-finance/invoices" element={<InvoiceManagement />} />
                <Route path="/human-resources/ac-finance/create-invoice" element={<CreateInvoice />} />
                <Route path="/human-resources/ac-finance/balances" element={<BalanceManagement />} />
                <Route path="/human-resources/ac-finance/payment-history" element={<StudentPaymentHistory />} />
                <Route path="/human-resources/finance/reports/payment-by-level" element={<PaymentByLevel />} />
                <Route path="/human-resources/finance/reports/payment-by-programme" element={<PaymentByProgramme />} />
                <Route path="/human-resources/finance/reports/payment-by-department" element={<PaymentByDepartment />} />
                <Route path="/human-resources/finance/reports/payment-by-faculty" element={<PaymentByFaculty />} />
                <Route path="/human-resources/finance/reports/outstanding" element={<OutstandingReport />} />
                <Route path="/human-resources/finance/reports/balance" element={<BalanceReport />} />
                <Route path="/human-resources/finance/reports/active-students-outstanding" element={<ActiveStudentsOutstanding />} />
                <Route path="/human-resources/finance/reports/scholarships" element={<ScholarshipReport />} />
                <Route path="/human-resources/finance/reports/scholarship-students" element={<ScholarshipStudentsReport />} />
                <Route path="/human-resources/finance/invoices" element={<FinanceInvoiceManagement />} />
                <Route path="/human-resources/finance/create-invoice" element={<FinanceCreateInvoice />} />
                <Route path="/human-resources/finance/invoices/report" element={<InvoiceReport />} />
                <Route path="/human-resources/finance/invoices/payment-report" element={<FinancePaymentReport />} />
                <Route path="/human-resources/finance/invoices/outstanding-report" element={<OutstandingBalanceReport />} />
                <Route path="/human-resources/finance/invoices/collection-register" element={<CollectionRegister />} />
                <Route path="/human-resources/finance/invoices/daily-collection" element={<DailyCollection />} />
                <Route path="/human-resources/finance/invoices/fee-type-collection" element={<FeeTypeCollection />} />
                <Route path="/human-resources/finance/invoices/installment-report" element={<InstallmentReport />} />
                <Route path="/human-resources/finance/invoices/by-faculty" element={<InvoiceByFaculty />} />
                <Route path="/human-resources/finance/invoices/by-department" element={<InvoiceByDepartment />} />
                <Route path="/human-resources/finance/invoices/by-course" element={<InvoiceByCourse />} />
                <Route path="/human-resources/finance/invoices/outstanding-by-faculty" element={<OutstandingByFaculty />} />
                <Route path="/human-resources/finance/invoices/outstanding-by-department" element={<OutstandingByDepartment />} />
                <Route path="/human-resources/finance/invoices/outstanding-by-course" element={<OutstandingByCourse />} />
                <Route path="/human-resources/finance/invoices/installment-by-faculty" element={<InstallmentByFaculty />} />
                <Route path="/human-resources/finance/invoices/installment-by-department" element={<InstallmentByDepartment />} />
                <Route path="/human-resources/finance/invoices/installment-by-course" element={<InstallmentByCourse />} />
                <Route path="/human-resources/finance/invoices/university-wide" element={<UniversityWide />} />

                {/* Scholarship Module Routes */}
                <Route path="/human-resources/scholarship/definitions" element={<ScholarshipDefinitions />} />
                <Route path="/human-resources/scholarship/students" element={<ScholarshipStudents />} />
                <Route path="/human-resources/scholarship/admission" element={<ScholarshipAdmission />} />
                <Route path="/human-resources/scholarship/academic" element={<AcademicScholarships />} />
                <Route path="/human-resources/scholarship/usage" element={<ScholarshipUsage />} />
                <Route path="/human-resources/scholarship/reports" element={<ScholarshipReportNew />} />

                <Route path="*" element={<Dashboard />} />
              </Routes>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
